<template>
  <div class="main">
    <a-form id="form" class="user-layout-login" ref="form" :form="form" @submit="handleSubmit">
      <a-form-item>
        <a-input size="large" type="text" placeholder="输入手机号"
                 v-decorator="['mobile', {rules: [{ required: true, message: '输入手机号' }], validateTrigger: 'blur'}] ">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input size="large" type="password" autocomplete="false" placeholder="密码" v-decorator="['password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-checkbox v-decorator="['rememberMe', { valuePropName: 'checked' }]">自动登录</a-checkbox>
      </a-form-item>

      <a-form-item style="margin-top:24px">
        <!--                <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="state.loginBtn" :disabled="state.loginBtn">-->
        <a-button size="large" type="primary" htmlType="submit" class="login-button">
          确定
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import userService from "@/service/user"
import {updateUserInfo} from "@/util/userInfoHolder"
import md5 from 'md5'

export default {

  data() {
    return {
      form: this.$form.createForm(this),
    };
  },
  mounted() {
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      const validateFieldsKey = ['mobile', 'password'];
      this.form.validateFields(validateFieldsKey, {force: true}, (err, values) => {
        values.password = md5(values.password)
        if (!err) {
          userService.login(values).then((response) => {
            updateUserInfo(response.data.userInfo, response.data.userToken)

            this.$notification.success({
              message: '欢迎',
              description: `${response.data.userInfo.name}，欢迎回来`
            })

            this.$router.push({path: '/'})
          });
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
